var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandWordpressStyleBlack = function SvgBrandWordpressStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#svg_icon_BrandWordpressStyleBlack__clip0_3953_120482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.706 12c0 4.074 2.368 7.596 5.802 9.265L2.598 7.81A10.26 10.26 0 0 0 1.705 12M18.95 11.48c0-1.272-.457-2.153-.85-2.839-.52-.848-1.01-1.566-1.01-2.414 0-.946.718-1.827 1.729-1.827.045 0 .088.006.133.008A10.26 10.26 0 0 0 12 1.706c-3.596 0-6.76 1.845-8.6 4.64.24.007.468.012.662.012 1.076 0 2.743-.13 2.743-.13.555-.033.62.782.066.847 0 0-.557.066-1.178.099l3.749 11.15 2.253-6.756-1.604-4.395c-.555-.032-1.08-.098-1.08-.098-.555-.032-.49-.88.065-.848 0 0 1.7.13 2.712.13 1.076 0 2.743-.13 2.743-.13.556-.033.62.782.066.848 0 0-.558.066-1.178.098l3.72 11.066 1.027-3.43c.445-1.425.784-2.447.784-3.329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.18 12.9-3.088 8.975a10.3 10.3 0 0 0 6.327-.164 1 1 0 0 1-.073-.142zM21.033 7.06c.044.329.07.68.07 1.06 0 1.044-.196 2.218-.783 3.687l-3.145 9.091A10.29 10.29 0 0 0 22.295 12c0-1.79-.458-3.473-1.262-4.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.384 0 0 5.383 0 12s5.384 12 12 12c6.617 0 12.001-5.383 12.001-12s-5.384-12-12-12m0 23.45C5.687 23.45.55 18.313.55 12 .55 5.686 5.687.55 12 .55S23.45 5.686 23.45 12 18.313 23.45 12 23.45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandWordpressStyleBlack__clip0_3953_120482"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandWordpressStyleBlack);
export { ForwardRef as ReactComponent };